import uavTaskListView from './src/uavTaskList/uavTaskListView.vue'

let views = {
    uavTaskListView
};

export default views;
